import { render } from "./BlList.vue?vue&type=template&id=7fecd698&scoped=true"
import script from "./BlList.vue?vue&type=script&lang=js"
export * from "./BlList.vue?vue&type=script&lang=js"

import "./BlList.vue?vue&type=style&index=0&id=7fecd698&scoped=true&lang=scss"

import exportComponent from "/var/www/blocks/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fecd698"]])

export default __exports__